export const sendEventsViaFetch = (endpoint, {
  data
}) => fetch(endpoint, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(data)
});